// *------ I M P O R T S ------*
import { Row, Col, Card } from "react-bootstrap";
// *------ A B O U T ------*

const Resume = () => {
  return (
    <Card>
      <Row>
      <iframe src="https://drive.google.com/file/d/1K-x_LUG-lhvD_oNEk9MPV6-m0hIuwgJy/preview" width="640" height="570" allow="autoplay"></iframe>
      </Row>
    </Card>
  );
};

export default Resume;
